import { useAuth } from "@/lib/auth";
import { Eye, X } from "lucide-react";

export function PreviewBanner() {
  const { previewFree, setPreviewFree } = useAuth();
  if (!previewFree) return null;
  return (
    <div data-testid="preview-free-banner"
      className="bg-[#60A5FA]/15 border-b border-[#60A5FA]/40 text-[#BFDBFE] text-xs sm:text-sm">
      <div className="max-w-3xl mx-auto px-4 py-2 flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 min-w-0">
          <Eye size={14} className="shrink-0" />
          <span className="truncate">Previewing as a <strong>Free user</strong> — this is what non-subscribers see. Your Pro access is unchanged.</span>
        </span>
        <button data-testid="exit-preview-button" onClick={() => setPreviewFree(false)}
          className="shrink-0 flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#60A5FA]/20 hover:bg-[#60A5FA]/30 font-semibold transition-colors">
          <X size={13} /> Exit preview
        </button>
      </div>
    </div>
  );
}
